import React from 'react';
import { AIInsightItem } from '../types';
import { Sparkles, ChevronRight } from 'lucide-react';

interface AIInsightsCardProps {
  insights: AIInsightItem[];
  title?: string;
  onSelectApp?: (appId: string) => void;
}

export const AIInsightsCard: React.FC<AIInsightsCardProps> = ({
  insights = [],
  title = 'AppStatsView AI Intelligence',
  onSelectApp
}) => {
  const safeInsights = Array.isArray(insights) ? insights : [];

  return (
    <div className="bg-gradient-to-br from-slate-900 via-[#0e1d38] to-[#0a3568] text-white rounded-3xl p-6 shadow-xl relative overflow-hidden">
      {/* Glow orb */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-sky-500/15 rounded-full blur-3xl pointer-events-none" />

      <div className="flex items-center justify-between mb-5 relative z-10">
        <div className="flex items-center gap-2.5">
          <span className="flex h-3 w-3 relative">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-400" />
          </span>
          <h3 className="text-base font-bold text-white tracking-tight">{title}</h3>
        </div>
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold bg-white/10 text-sky-300 px-2.5 py-0.5 rounded-full backdrop-blur-md border border-white/10">
          <Sparkles className="w-3 h-3 text-sky-300" strokeWidth={2} />
          <span>Live Neural Synthesis</span>
        </span>
      </div>

      <div className="space-y-3 relative z-10">
        {safeInsights.map((item) => (
          <div
            key={item.id}
            className="p-4 rounded-2xl bg-white/[0.07] hover:bg-white/[0.12] border border-white/10 backdrop-blur-md transition-all duration-200"
          >
            <div className="flex items-center justify-between gap-2 mb-1">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 rounded bg-sky-500/20 text-sky-300 border border-sky-400/20">
                  {item.type}
                </span>
                {item.appName && onSelectApp && item.appId && (
                  <button
                    onClick={() => onSelectApp(item.appId!)}
                    className="inline-flex items-center gap-0.5 text-xs font-bold text-white hover:text-sky-300 transition-colors"
                  >
                    <span>{item.appName}</span>
                    <ChevronRight className="w-3 h-3" strokeWidth={2} />
                  </button>
                )}
              </div>
              <span className="text-[11px] text-slate-400">{item.timestamp}</span>
            </div>

            <h4 className="text-sm font-semibold text-white mb-1">{item.title}</h4>
            <p className="text-xs text-slate-300 leading-relaxed">{item.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
